import styled from 'styled-components';

export const Section = styled.section`
    width: 100%;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
`;
